export default "__VITE_ASSET__DD2Elv4u__"